/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TimelineArrowRegular from './timeline-arrow-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TimelineArrowRegular {...validProps} />;
}

SvgComponent.iconName = 'timelineArrowRegular';

export const TimelineArrowRegularIcon = svgIconWrapper(SvgComponent);
